import React from "react";
import { Header, Segment } from "semantic-ui-react";
import AdditionalDocumentTable from "features/AdditionalDocuments/AdditionalDocumentTable";
import AddAdditionalDocumentModal from "features/AdditionalDocuments/AddAdditionalDocumentModal";
import {
  getIntroductionTemplates,
  getAssignmentTemplatesSPV,
  getAssignmentTemplatesCustomer,
  uploadIntroductionTemplate,
  uploadAssignmentTemplateSPV,
  uploadAssignmentTemplateCustomer,
  approveAdditionalDocument,
  downloadAdditionalDocument,
} from "./actions";

const IntroductionTemplateModal = ({
  dealerId: dealerOfficeId,
  onSubmitted,
}) => (
  <AddAdditionalDocumentModal
    submitAction={uploadIntroductionTemplate}
    triggerText="Upload New Introduction Template"
    headerText="New Introduction Template"
    onSubmitted={onSubmitted}
    dealerOfficeId={dealerOfficeId}
  />
);

const AssignmentTemplateSPVModal = ({
  dealerId: dealerOfficeId,
  onSubmitted,
}) => (
  <AddAdditionalDocumentModal
    submitAction={uploadAssignmentTemplateSPV}
    triggerText="Upload New Assignment Template from SPV"
    headerText="New Assignment Template from SPV"
    onSubmitted={onSubmitted}
    dealerOfficeId={dealerOfficeId}
  />
);

const AssignmentTemplateCustomerModal = ({
  dealerId: dealerOfficeId,
  onSubmitted,
}) => (
  <AddAdditionalDocumentModal
    submitAction={uploadAssignmentTemplateCustomer}
    triggerText="Upload New Assignment Template from Customer"
    headerText="New Assignment Template from Customer"
    onSubmitted={onSubmitted}
    dealerOfficeId={dealerOfficeId}
  />
);

const AdditionalDocuments = ({ dealerOfficeId }) => {
  return (
    <Segment>
      <Header as="h3">Introduction Template</Header>
      <AdditionalDocumentTable
        dealerId={dealerOfficeId}
        loadAction={getIntroductionTemplates}
        emptyMessage="No Introduction Template"
        AddModal={IntroductionTemplateModal}
        approveAction={approveAdditionalDocument}
        downloadAction={downloadAdditionalDocument}
      />
      <Header as="h3">Assignment Template from SPV</Header>
      <AdditionalDocumentTable
        dealerId={dealerOfficeId}
        loadAction={getAssignmentTemplatesSPV}
        emptyMessage="No Assignment Template from SPV"
        AddModal={AssignmentTemplateSPVModal}
        approveAction={approveAdditionalDocument}
        downloadAction={downloadAdditionalDocument}
      />
      <Header as="h3">Assignment Template from Customer</Header>
      <AdditionalDocumentTable
        dealerId={dealerOfficeId}
        loadAction={getAssignmentTemplatesCustomer}
        emptyMessage="No Assignment Template from Customer"
        AddModal={AssignmentTemplateCustomerModal}
        approveAction={approveAdditionalDocument}
        downloadAction={downloadAdditionalDocument}
      />
    </Segment>
  );
};

export default AdditionalDocuments;
